import { isNative } from 'lodash';

interface MobileShareDetails {
  title?: string;
  text?: string;
  url?: string;
  files?: File[];
}

export const useMobileShare = () => {
  const share = ({ text, title, url, files }: MobileShareDetails) =>
    navigator.share({ text, title, url, files });

  return { isNativeShareSupported: isNative(navigator.share), share };
};

export default useMobileShare;
